import { Box, Text } from '@chakra-ui/react';

import getStatusVariant from 'View/reschedule/helper/getStatusVariant';
import getStatusIcon from 'View/reschedule/helper/getStatusIcon';

import styles from './styles.module.css';

const StatusBadge = ({ children, status, className = '' }, props) => {
  const variant = getStatusVariant(status);
  const icon = getStatusIcon(status);

  return (
    <Box
      className={`
        ${styles['status-badge']}
        ${styles[`status-badge--${variant}`]}
        ${className}
      `}
      {...props}
    >
      {icon}
      <Text className={styles['status-badge__text']}>{children}</Text>
    </Box>
  );
};

export default StatusBadge;
